export default "__VITE_ASSET__9ba10126__"